var CustomARButton = {
  createButton: function (renderer, sessionInit = {}, fallbackModeInit) {
    const button = document.querySelector("#start-button");
    button.classList.add("show");
    function showStartAR(/*device*/) {
      var currentSession = null;

      function onSessionStarted(session) {
        // TODO: find a way to test on browsers without domOverlay to be able to do the correct check below (but with WebXR)
        // because there's no other way to find out whether dom overlay is supported or not (UA sniffing but it's not reliable)
        if (!session.domOverlayState) {
          session.end();
          fallbackModeInit();
          return;
        }
        console.log(session.domOverlayState);
        console.log(session.domOverlayState.type);
        session.addEventListener("end", onSessionEnded);

        renderer.xr.setReferenceSpaceType("local");
        renderer.xr.setSession(session);
        button.textContent = "STOP AR";

        currentSession = session;
      }

      function onSessionEnded() {
        currentSession.removeEventListener("end", onSessionEnded);

        button.textContent = "START AR";

        currentSession = null;
      }

      button.textContent = "START AR";
      button.addEventListener("click", () => {
        if (currentSession === null) {
          navigator.xr
            .requestSession("immersive-ar", sessionInit)
            .then(onSessionStarted);
        } else {
          currentSession.end();
        }
      });
    }

    function showARNotSupported() {
      button.innerHTML = `Click to start`;
      button.addEventListener("click", fallbackModeInit, { once: true });
    }

    if ("xr" in navigator) {
      navigator.xr
        .isSessionSupported("immersive-ar")
        .then(function (supported) {
          supported ? showStartAR() : showARNotSupported();
        })
        .catch(showARNotSupported);
    } else {
      showARNotSupported();
      return;
    }
  },
};

export { CustomARButton };
